module.exports = __webpack_public_path__ + "img/tp-gauge.3c317046.png";